document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initCalibres();
  initCountUp();
});

function initReveal() {
  var els = document.querySelectorAll('.ah-reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('ah-visible'); });
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        var delay = entry.target.getAttribute('data-reveal-delay') || 0;
        setTimeout(function () { entry.target.classList.add('ah-visible'); }, delay);
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
  els.forEach(function (el) { io.observe(el); });
}

function initCountUp() {
  var els = document.querySelectorAll('[data-ah-count]');
  if (!els.length || !('IntersectionObserver' in window)) return;
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      io.unobserve(entry.target);
      var el = entry.target;
      var target = parseFloat(el.getAttribute('data-ah-count')) || 0;
      var suffix = el.getAttribute('data-ah-suffix') || '';
      var duration = 1400;
      var start = null;
      function step(ts) {
        if (!start) start = ts;
        var progress = Math.min((ts - start) / duration, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        var value = Math.round(target * eased);
        el.textContent = value + suffix;
        if (progress < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    });
  }, { threshold: 0.4 });
  els.forEach(function (el) { io.observe(el); });
}

var AH_CALIBRE_ESCALA = {
  jumbo: { size: 5, weight: '74 a 81,9 g' },
  super: { size: 4, weight: '68 a 73,9 g' },
  extra: { size: 3, weight: '61 a 67,9 g' },
  primera: { size: 2, weight: '54 a 60,9 g' },
  mediano: { size: 1, weight: '47 a 53,9 g' }
};

function ahEscalaHtml(calibreName) {
  var key = (calibreName || '').toLowerCase();
  var match = AH_CALIBRE_ESCALA.extra;
  Object.keys(AH_CALIBRE_ESCALA).forEach(function (k) {
    if (key.indexOf(k) > -1) match = AH_CALIBRE_ESCALA[k];
  });
  var eggs = '';
  for (var i = 1; i <= 5; i++) {
    eggs += '<span class="ah-escala__egg ah-escala__egg--' + i + (i === match.size ? ' is-active' : '') + '"></span>';
  }
  return '<div class="ah-escala"><div class="ah-escala__eggs">' + eggs + '</div><span class="ah-escala__weight">' + match.weight + '</span></div>';
}

function initCalibres() {
  var roots = document.querySelectorAll('[data-ah-calibres]');
  if (!roots.length) return;

  roots.forEach(function (root) {
    var tabs = root.querySelectorAll('[data-ah-tab]');
    var panels = root.querySelectorAll('[data-ah-panel]');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        if (tab.hasAttribute('disabled')) return;
        var target = tab.getAttribute('data-ah-tab');
        tabs.forEach(function (t) { t.classList.toggle('is-active', t === tab); });
        panels.forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-ah-panel') === target); });
      });
    });

    var cards = root.querySelectorAll('[data-ah-card]');
    if (!cards.length) return;
    var detail = root.querySelector('[data-ah-detail]');

    function selectCard(card) {
      cards.forEach(function (c) { c.classList.toggle('is-selected', c === card); });
      if (!detail) return;
      var name = card.getAttribute('data-name');
      var meta = card.getAttribute('data-meta');
      var price = card.getAttribute('data-price');
      var img = card.getAttribute('data-img');
      var url = card.getAttribute('data-url');
      var calibre = card.getAttribute('data-calibre');
      var detailName = detail.querySelector('[data-detail-name]');
      var detailMeta = detail.querySelector('[data-detail-meta]');
      var detailPrice = detail.querySelector('[data-detail-price]');
      var detailImg = detail.querySelector('[data-detail-img]');
      var detailLink = detail.querySelector('[data-detail-link]');
      var detailEscala = detail.querySelector('[data-detail-escala]');
      if (detailName) detailName.textContent = name;
      if (detailMeta) detailMeta.textContent = meta;
      if (detailPrice) detailPrice.textContent = price;
      if (detailImg && img) detailImg.setAttribute('src', img);
      if (detailLink && url) detailLink.setAttribute('href', url);
      if (detailEscala) detailEscala.innerHTML = ahEscalaHtml(calibre);
    }

    cards.forEach(function (card) {
      card.addEventListener('click', function () { selectCard(card); });
    });
    selectCard(cards[0]);
  });
}
